import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
type Priority = 'critical' | 'high' | 'medium' | 'low';
type AlertInfo = {
  alertId: string;
  priority: Priority;
  date: string;
  rules?: string[];
};

// A low-priority alert isn't a warning; only the levels that ask for attention get a tone.
const ALERT_VARIANT: Record<Priority, 'error' | 'warning' | 'neutral'> = {
  critical: 'error',
  high: 'error',
  medium: 'warning',
  low: 'neutral'
};
type InvestigationSummaryProps = {
  name?: string; // used by extractBlockTitle for the block panel header
  alert?: AlertInfo;
};
const InvestigationSummary = t0 => {
  const $ = _c(5);
  const {
    alert
  } = t0;
  if (!alert?.rules || alert.rules.length === 0) {
    return null;
  }
  const t1 = ALERT_VARIANT[alert.priority];
  let t2;
  if ($[0] !== alert.rules) {
    t2 = alert.rules.join(" \xB7 ");
    $[0] = alert.rules;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <InlineAlert variant={t1}>{t2}</InlineAlert>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default InvestigationSummary;